import assign from 'lodash/assign';

const DAY = 24 * 60 * 60 * 1000;
const SESSION_KEY = 'gladlySession';

export default class SmoochSessionStorage {
  getSession() {
    let session = localStorage.getItem(SESSION_KEY);
    if (!session) {
      return null;
    }

    session = JSON.parse(session);
    const oneDayAgo = Date.now() - DAY;
    if (session.created < oneDayAgo) {
      this.removeSession();
      session = null;
    }

    return session;
  }

  setSession(session) {
    if (!session) {
      return;
    }

    if (!session.created) {
      session.created = Date.now();
    }

    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  }

  patchSession(sessionPatch) {
    let session = this.getSession();
    session = assign(session, sessionPatch);
    this.setSession(session);
  }

  removeSession() {
    localStorage.removeItem(SESSION_KEY);
  }
}
